import { Company, Employee } from "../../types";
import styled from "styled-components";
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Typography,
} from "@mui/material";
import { ChevronDown } from "lucide-react";
import { useGetEmployee, useUpdateLanguage } from "../../hooks/employeeHooks";
import { useContext, useEffect, useState } from "react";
import { EmployeeContext } from "../../context/EmployeeContext";

type Props = {
    employee?: Employee;
    company?: Company;
};

export const EmployeeInfo = (props: Props) => {
    const updateMutation = useUpdateLanguage();
    const [language, setLanguage] = useState(props.employee?.language ?? "");
    const { employee } = useContext(EmployeeContext);

    const employeeQuery = useGetEmployee(employee.companyId, employee.id);

    useEffect(() => {
        if (employeeQuery?.data?.language) {
            setLanguage(employeeQuery.data.language);
        }
    }, [employeeQuery?.data?.language]);
    const handleSubmit = (e: SelectChangeEvent<string>) => {
        if (!props.employee) return;
        setLanguage(e.target.value);
        if (props.employee) {
            updateMutation.mutate(
                {
                    employee: {
                        name: props.employee.name ?? "",
                        email: props.employee.email ?? "",
                        language: e.target.value || "",
                    },
                },
                {
                    onSuccess: () => {
                        void employeeQuery.refetch();
                    },
                },
            );
        }
    };

    return (
        <EmployeeInfoWrapper>
            <RowWrapper>
                <Typography sx={sxPoppins} fontWeight={600} fontSize={18} color="#8c8c8c">
                    Company:
                </Typography>
                <Typography sx={sxPoppins} fontSize={18} fontWeight={"600"}>
                    {props.company?.name}
                </Typography>
            </RowWrapper>
            <RowWrapper>
                <Typography sx={sxPoppins} fontWeight={600} fontSize={18} color="#8c8c8c">
                    Email:
                </Typography>
                <Typography sx={sx} fontSize={16} fontWeight="400">
                    {props.employee?.email}
                </Typography>
            </RowWrapper>
            {props.employee?.phone && (
                <RowWrapper>
                    <Typography sx={sxPoppins} fontWeight={600} fontSize={18} color="#8c8c8c">
                        Phone:
                    </Typography>
                    <Typography sx={sx} fontSize={16} fontWeight="400">
                        {props.employee?.phone}
                    </Typography>
                </RowWrapper>
            )}
            <RowWrapper>
                <Typography sx={sxPoppins} fontWeight={600} fontSize={18} color="#8c8c8c">
                    Name:
                </Typography>
                <Typography sx={sx} fontSize={16} fontWeight="400">
                    {props.employee?.name}
                </Typography>
            </RowWrapper>
            {props.employee?.lastName && (
                <RowWrapper>
                    <Typography sx={sxPoppins} fontWeight={600} fontSize={18} color="#8c8c8c">
                        Lastname:
                    </Typography>
                    <Typography sx={sx} fontSize={16} fontWeight="400">
                        {props.employee?.lastName}
                    </Typography>
                </RowWrapper>
            )}
            <RowWrapper>
                <Typography sx={sxPoppins} fontWeight={600} fontSize={18} color="#8c8c8c">
                    Role:
                </Typography>
                <Typography sx={sx} fontSize={16} fontWeight="400">
                    {props.employee?.role}
                </Typography>
            </RowWrapper>
            <RowWrapper>
                <Typography sx={sxPoppins} fontWeight={600} fontSize={18} color="#8c8c8c">
                    Language:
                </Typography>
                {/* <Typography sx={sx} fontSize={16} fontWeight="400">
                    {props.employee?.role}
                </Typography> */}
                <FormControl>
                    <InputLabel
                        sx={{
                            fontFamily: "'Yllw Sans a1 241219', sans-serif",
                            fontSize: "16px",
                            fontWeight: "400",
                            color: "rgba(0, 0, 0, 0.50)",
                        }}
                    >
                        Language
                    </InputLabel>
                    <Select
                        label="Language"
                        // value={props.employee?.language ?? ""}
                        value={language || employeeQuery?.data?.language}
                        onChange={handleSubmit}
                        IconComponent={ChevronDown}
                        // defaultValue={props.employee?.language ?? ""}
                        sx={sxMenuItem}
                        size="small"
                    >
                        <MenuItem value={"en"} sx={sxMenuItem}>
                            English
                        </MenuItem>
                        <MenuItem value={"sv"} sx={sxMenuItem}>
                            Swedish
                        </MenuItem>
                        <MenuItem value={"dk"} sx={sxMenuItem}>
                            Danish
                        </MenuItem>
                        <MenuItem value={"no"} sx={sxMenuItem}>
                            Norwegian
                        </MenuItem>
                        <MenuItem value={"fi"} sx={sxMenuItem}>
                            Finnish
                        </MenuItem>
                    </Select>
                </FormControl>
            </RowWrapper>
        </EmployeeInfoWrapper>
    );
};

const EmployeeInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    gap: 1rem;
`;

const RowWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    h6:first-child {
        max-width: 150px;
        width: 100%;
        color: #8c8c8c;
    }
    #8C8C8C h6:nth-child(2) {
        display: flex;
        flex-shrink: 1;
        word-break: break-all;
    }
`;
const sx = {
    fontFamily: "'Yllw Sans a1 241219', sans-serif",
};
const sxPoppins = { fontFamily: "'Poppins', sans-serif" };

const sxMenuItem = {
    fontFamily: "'Yllw Sans a1 241219', sans-serif",
    fontSize: "16px",
    fontWeight: "400",
    color: "black",
    opacity: 1,
    width: "100px",
};
